module.exports = __webpack_public_path__ + "img/proposal.1419c46.webp";